import React from 'react';
import { useLogin } from '../hooks/useLogin';

const DontHaveAccount = () => {
	const { dontHaveAccount } = useLogin();

	return (
		<a href="/" className="vtex-login-2-x-dontHaveAccount dontHaveAccount link dim c-link t-small">
			{dontHaveAccount}
		</a>
	);
};

export default DontHaveAccount;
